import { Alert, Stack } from "@mui/material";

export const FullPageError: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <Stack alignItems="center" height="100%" justifyContent="center" spacing={4}>
            <Alert severity="error">{children}</Alert>
        </Stack>
    );
};
